import React from 'react';
import Layout from '@cld/list-item-layout';
import FolderIcon from '../FolderIcon';

const TreeNodeWithIcons = ({ name, kind }) => (
  <Layout>
    <FolderIcon kind={kind} />
    <span>{name}</span>
  </Layout>
);

export default TreeNodeWithIcons;
